import React from 'react';
import { useAddSubscriptionPlanPriceComponent } from './useAddSubscriptionPlanPriceComponent';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddSubscriptionPlanPrice.styles';
import theme from '../../../../styles/theme';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import { ISubscriptionPlanPrice } from '../../../../types/interfaces/subscription-plan-price';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';

interface IAddSubscriptionPlanPriceProps {
  subscriptionPlanPrice: ISubscriptionPlanPrice;
  onClose: () => void;
}

export default function AddSubscriptionPlanPrice(
  props: IAddSubscriptionPlanPriceProps,
) {
  const { subscriptionPlanPrice, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading, planOptions } =
    useAddSubscriptionPlanPriceComponent(onClose, subscriptionPlanPrice);
  const { classes } = useStyles(theme);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('superAdminDashboard.stripePriceId')}
              fullWidth
              name="stripePriceId"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.value')}
              fullWidth
              name="value"
              type="number"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.plan')}
              name="plan"
              showSearch={false}
              disableClear
              options={planOptions}
              defaultValue={planOptions?.find(
                (r) => r.id === formik.values.plan?.id,
              )}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="current"
                  checked={formik.values.current}
                  onChange={(e) =>
                    formik.setFieldValue('current', e.target.checked)
                  }></Checkbox>
              }
              label={t('common.current')}
            />
          </Grid>
        </Grid>
        <Box className={classes.addSubscriptionPlanPricesButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {subscriptionPlanPrice ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
